import { useTranslation } from "react-i18next";
import { subDays } from "date-fns";

import { Chart } from "@/components/chart";
import { useResource } from "@/hooks/resources";

type TimePlayedChartProps = {
  childId?: string | number;
  demo?: boolean;
};

const dateFormatter = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

export const TimePlayedChart = ({ childId, demo }: TimePlayedChartProps) => {
  const { t } = useTranslation("charts");

  const [timePlayed] = useResource<Array<{ week: string, count: number }>>(`/reports/time_played_for_all_songs?child_id=${childId}`)

  let totalDurationInMinutes = 0;
  const demoDurationsInMinutes = [0, 4, 7, 0, 10, 8, 0, 9, 11, 0, 6, 3].map((durationInMinutes, index) => ({
    week: dateFormatter.format(subDays(new Date(), 7 * (12 - index))),
    durationInMinutes,
    totalDurationInMinutes: totalDurationInMinutes += durationInMinutes
  }))

  return (
    <Chart
      options={{
        tooltip: {
          trigger: "axis",
          valueFormatter: (value) => t("timePlayed.minutes", { count: Number(value) }),
        },
        xAxis: { name: "Week", type: "category" },
        yAxis: [{ name: "Minutes" }, { name: "Total Minutes" }],
        series: [{ type: "bar", name: "Weekly", yAxisIndex: 0 }, { type: "line", name: "All Time", yAxisIndex: 1, smooth: true }],
        dataset: {
          dimensions: ["week", "durationInMinutes", "totalDurationInMinutes"],
          source: demo ? demoDurationsInMinutes : (timePlayed || [])
        }
      }}
      className="h-[400px]"
    />
  )
}
